
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDisplayBrillianceProposal as ObiDisplayBrillianceProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-display-brilliance-proposal.js';
 
 
 

 
 export const ObiDisplayBrillianceProposal = createComponent({
   react: React,
   tagName: 'obi-display-brilliance-proposal',
   elementClass: ObiDisplayBrillianceProposalElement,
   events: {
     
   }
  });
 
 